module.exports = __webpack_public_path__ + "media/referral/mosaic-8d0b36ee.png";